import React from 'react';
export function IdentitySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream relative overflow-hidden" data-id="element-104">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-forest/5 rounded-l-full blur-3xl -z-10 transform translate-x-1/4" data-id="element-105"></div>

      <div className="max-w-3xl mx-auto" data-id="element-106">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-12 text-center" data-id="element-107">
          Imagina Tu Próxima Semana
        </h2>

        <div className="prose prose-lg md:prose-xl prose-p:text-dark/80 mx-auto space-y-6" data-id="element-108">
          <p data-id="element-109">Es lunes por la mañana.</p>
          <p data-id="element-110">Suena el despertador.</p>
          <p data-id="element-111">Te despiertas.</p>
          <p data-id="element-112">
            Y antes de pensar en nada, antes de revisar el teléfono, antes del
            café...
          </p>

          <p className="text-xl md:text-2xl font-bold text-forest my-8" data-id="element-113">
            Notas algo diferente.
          </p>

          <p data-id="element-114">
            Tu vientre está plano. No perfectamente plano, sino diferente al de
            ayer. Más ligero. Sin esa presión habitual.
          </p>
          <p data-id="element-115">
            Te incorporas sin ese cansancio denso que llevabas meses
            arrastrando.
          </p>
          <p data-id="element-116">Vas al espejo.</p>
          <p className="font-bold text-dark" data-id="element-117">
            Y esta vez no apartas la mirada.
          </p>

          <hr className="border-forest/20 my-10" data-id="element-118" />

          <p data-id="element-119">
            El miércoles llegas a casa a las 8 PM con el mismo cansancio de
            siempre. Pero esta vez, en lugar de ese agobio de "¿qué como que no
            me haga daño?", abres tu protocolo, eliges una receta, y en 15
            minutos tienes una cena deliciosa en la mesa.
          </p>
          <p data-id="element-120">Te vas a la cama.</p>
          <p data-id="element-121">Duermes profundamente.</p>

          <hr className="border-forest/20 my-10" data-id="element-122" />

          <p data-id="element-123">
            El viernes, alguien en tu trabajo te pregunta si hiciste algo
            diferente.
          </p>
          <p data-id="element-124">Tienes más brillo. Más energía. Algo cambió.</p>
        </div>

        <div className="mt-16 bg-white p-8 rounded-2xl shadow-warm border border-gold/20 text-center" data-id="element-125">
          <p className="text-xl md:text-2xl font-serif font-bold text-forest mb-4" data-id="element-126">
            Esa mujer no está lejos. Está a 7 días de distancia.
          </p>
          <p className="text-lg font-bold text-urgency" data-id="element-127">
            Y a un clic de distancia ahora mismo.
          </p>
        </div>
      </div>
    </section>;
}